// Components
import About from "../components/Home/About";
import Clients from "../components/Home/Clients";
import Front from "../components/Home/Front";
import Work from "../components/Home/Work";
import WorkWithUs from "../components/Home/WorkWithUs";


export default function Home() {
  return (
    <main className="w-full overflow-x-hidden" style={{ backgroundColor: "#ffffff" }}>
<Front />
  <About />
      <Clients />
<Work />
      <WorkWithUs />

    </main>
  );
}